import {createReducer} from '@reduxjs/toolkit';
import keyBy from 'lodash/keyBy';

import {selectMosaic, selectMosaicByName} from '@explorer/actions/mosaics';
import {
  fetchSeriesRequest,
  selectSeries,
  setActiveSeriesId,
  setIntervals,
} from '@explorer/actions/series';
import {SR_SERIES_IDS} from '@explorer/constants';
import * as intervals from '@explorer/util/intervals';

export const initialState = {
  loading: true,
  error: null,
  byId: {},
  selectedId: '',
  activeId: null,
  lastSelectedMosaics: {},
  intervalsFilter: {
    [intervals.WEEK]: true,
    [intervals.BIWEEK]: true,
    [intervals.MONTH]: true,
    [intervals.QUARTER]: true,
  },
};
const series = createReducer(initialState, builder => {
  builder.addCase(fetchSeriesRequest.pending, state => {
    state.loading = true;
    state.error = null;
  });

  builder.addCase(fetchSeriesRequest.fulfilled, (state, {payload: series}) => {
    const newSeries = series
      .filter(s => !s.name.includes('SIF', 0) && s.interval !== intervals.DAY)
      .map(s => ({
        ...s,
        supports: {
          numpy: true, // for now all basemaps support "enhancements"
          indexes: s.datatype === 'uint16' || SR_SERIES_IDS.indexOf(s.id) >= 0,
        },
      }));

    const byId = keyBy(newSeries, 'id');

    state.loading = false;
    state.byId = byId;
  });

  builder.addCase(fetchSeriesRequest.rejected, (state, {error}) => {
    state.loading = false;
    state.error = error;
  });

  builder.addCase(selectSeries, (state, {payload: seriesId}) => {
    state.selectedId = seriesId;
  });

  builder.addCase(setActiveSeriesId, (state, {payload: seriesId}) => {
    state.activeId = seriesId;
  });

  builder.addCase(selectMosaic.fulfilled, (state, {payload: mosaic}) => {
    if (state.selectedId) {
      state.lastSelectedMosaics[state.selectedId] = mosaic?.id;
    }
  });

  builder.addCase(selectMosaicByName.fulfilled, (state, {payload: mosaic}) => {
    if (state.selectedId) {
      state.lastSelectedMosaics[state.selectedId] = mosaic?.id;
    }
  });

  builder.addCase(setIntervals, (state, {payload}) => {
    state.intervalsFilter = {...state.intervalsFilter, ...payload};
  });
});

export default series;
